import classNames from 'classnames';
import { forwardRef } from 'react';
const pulsingOrbContainerCss = "p15fo7l9";
const PulsingOrbContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(pulsingOrbContainerCss, props.className)} />;
});

// Reusable PulsingOrb component that can optionally wrap content
export const PulsingOrb = ({
  children,
  isVisible = true
}) => {
  if (!isVisible) return children || null;
  return <PulsingOrbContainer>
      {children}
    </PulsingOrbContainer>;
};

require("./pulsing_orb.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pulsing_orb.js");